import React from 'react';
import { Link } from 'react-router-dom';
import { blogs } from '../../portfolio';

const BlogsPage = () => {
  return (
    <div className="split-layout">
      {/* LEFT COLUMN: List of blogs */}
      <div className="split-sidebar" style={{ width: 'min(400px, 100%)' }}>
        <h3 className="section-title" style={{ marginBottom: '24px' }}>Writing</h3>
        <div className="writing-list" style={{ gap: '0' }}>
          {blogs.map((blog, idx) => {
            const date = new Date(blog.publishedDate);
            const yearStr = date.getFullYear().toString();
            const dateStr = date.toLocaleDateString('en-US', { month: 'long', day: '2-digit', year: 'numeric' });

            return (
              <Link 
                key={idx} 
                to={`/blogs/${blog.slug}`} 
                className="writing-item" 
                style={{
                  padding: '16px 12px',
                  borderRadius: '6px',
                  transition: 'background 0.2s',
                  alignItems: 'flex-start'
                }}
              >
                <div style={{ flex: 1, paddingRight: '16px', minWidth: 0 }}>
                  <div className="writing-title" style={{ fontWeight: '600', marginBottom: '4px' }}>{blog.title}</div>
                  <div className="writing-date">{dateStr}</div>
                </div>
                <div className="writing-date" style={{ opacity: 0.6 }}>{yearStr}</div>
              </Link>
            );
          })}
        </div>
      </div>

      {/* RIGHT COLUMN: Empty or initial state */}
      <div className="split-content" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', opacity: 0.5 }}>
        <p>Select a post to read</p>
      </div>
    </div>
  );
};

export default BlogsPage;
